import { Box } from '@mui/material';
import * as React from 'react';
import { FunctionComponent } from 'react';
import TextContent from './TextContent';
import ResponsiveSplitSection from '../common/ResponsiveSplitSection';
import { AboutSustainabilitySocialContent } from '../../graphql/pimcore/modules/siteContent/types/AboutSustainabilityContent';
import SustainabilityContainer from './SustainabilityContainer';
import SocialTab from './SocialTab';

interface SocialPageProps {
    cmsContent: AboutSustainabilitySocialContent;
}

const SocialPage: FunctionComponent<SocialPageProps> = ({ cmsContent }) => {
    const textContent = (
        <Box sx={{ marginTop: '1rem' }}>
            <TextContent
                name={'social'}
                content1={<div dangerouslySetInnerHTML={{ __html: cmsContent.mainText.content }} />}
            />
        </Box>
    );

    return (
        <>
            <ResponsiveSplitSection
                textContent={textContent}
                backgroundColor={'white'}
                smallScreenTextFirst={false}
                imageSrc={cmsContent.mainImage.imageUrl}
                bigScreenAlignItem="flex-start"
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F8F8F8',
                }}
            >
                <SustainabilityContainer backgroundColor={'#F8F8F8'}>
                    <SocialTab cmsContent={cmsContent} />
                </SustainabilityContainer>
            </Box>
        </>
    );
};

export default SocialPage;
